/* ============================================================
   WowSticker — "Trova lo sticker giusto"
   Consulenza guidata + chat AI, basate sul CATALOGO REALE (catalog.js).
   Il prezzo NON è mai inventato: viene letto dalle matrici a listino
   (window.WowCatalog). Formati su misura → stima al m².
   ============================================================ */
(function(){
  'use strict';
  const root = document.getElementById('guide');
  const C = window.WowCatalog;
  if(!C){ if(root) root.innerHTML = '<p style="padding:24px">Catalogo non disponibile.</p>'; return; }

  const CT = C.META.contacts;
  const fmt = n => '€' + Number(n).toLocaleString('it-IT',{minimumFractionDigits:2, maximumFractionDigits:2});
  const fmt0 = n => '€' + Math.round(n);
  const trim = n => String(Math.round((+n)*10)/10);
  const esc = s => String(s).replace(/"/g,'&quot;');
  const escHtml = s => String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const sizeLabel = s => s ? s.replace('x','×')+' cm' : '';

  /* ---------- guided wizard questions ---------- */
  const QUESTIONS = [
    { id:'uso', q:'A cosa ti serviranno gli sticker?', sub:'Parti dall’uso: al materiale pensiamo noi.', icon:'flag', opts:[
      { v:'packaging', ic:'inventory_2',  t:'Packaging e spedizioni', d:'Scatole, confezioni, chiusura pacchi' },
      { v:'laptop',    ic:'devices',      t:'Laptop, borracce, oggetti', d:'Uso quotidiano su ogni superficie' },
      { v:'vetrine',   ic:'storefront',   t:'Vetrine e vetri', d:'Negozi, locali, finestre' },
      { v:'abbigliamento', ic:'checkroom',t:'T-shirt e tessuti', d:'Capi e abbigliamento (a caldo)' },
      { v:'metallo',   ic:'kitchen',      t:'Frigo e superfici metalliche', d:'Magneti e gadget promozionali' },
      { v:'auto',      ic:'directions_car',t:'Auto, insegne, scritte', d:'Lettering intagliato per esterni' },
      { v:'lusso',     ic:'redeem',       t:'Inviti e confezioni regalo', d:'Effetto elegante e premium' },
      { v:'merch',     ic:'auto_awesome', t:'Merch e brand', d:'Massimo impatto, effetto wow' },
    ]},
    { id:'superficie', q:'Su che superficie andranno?', sub:'Ci aiuta a confermare il materiale.', icon:'texture', opts:[
      { v:'carta',    ic:'package_2',    t:'Carta e cartone', d:'Buste, scatole, packaging' },
      { v:'vetro',    ic:'window',       t:'Vetro', d:'Vetrine, finestre, bottiglie' },
      { v:'plastica', ic:'water_bottle', t:'Plastica o metallo', d:'Borracce, laptop, contenitori' },
      { v:'tessuto',  ic:'checkroom',    t:'Tessuto', d:'Magliette, borse in stoffa' },
      { v:'mista',    ic:'category',     t:'Superfici diverse / non so', d:'Scegliamo il più versatile' },
    ]},
    { id:'size', q:'Che dimensione, indicativamente?', sub:'Misure standard a listino; per misure libere c’è il formato su misura.', icon:'straighten', opts:[
      { v:'5x5',   ic:'crop_square', t:'Piccola', d:'circa 5×5 cm' },
      { v:'7x7',   ic:'crop_din',    t:'Media', d:'circa 7×7 cm' },
      { v:'10x10', ic:'crop_free',   t:'Grande', d:'circa 10×10 cm' },
      { v:'12x12', ic:'fullscreen',  t:'Molto grande', d:'circa 12×12 cm' },
    ]},
    { id:'qty', q:'Quanti te ne servono?', sub:'Più alta la quantità, più basso il prezzo unitario.', icon:'tag', opts:[
      { v:'50',  ic:'counter_1', t:'50', d:'il minimo a listino' },
      { v:'100', ic:'counter_2', t:'100', d:'il più richiesto' },
      { v:'300', ic:'counter_3', t:'300', d:'buon risparmio' },
      { v:'500', ic:'counter_4', t:'500 o più', d:'prezzo/pz minimo' },
    ]},
  ];

  const USO_TIPO = { packaging:'vinile', laptop:'vinile', vetrine:'trasparente', abbigliamento:'dtf', metallo:'magnetico', auto:'prespaziato', lusso:'oro', merch:'olografico' };

  /* ---------- build a recommendation CARD from a normalized rec ---------- */
  // rec = { tipo, size, qty, w?, h?, reason? }
  function buildCard(rec){
    const tipo = rec.tipo;
    const qty = parseInt(rec.qty,10) || 50;
    const card = { tipo, tipoLabel: C.TIPO_LABEL[tipo] || tipo, qty, reasons:[], contacts:false };
    const TAGLI = { sagomato:'Sagomato', quadrato:'Squadrato', angoli:'Angoli arrotondati', tondo:'Tondo' };
    if(rec.taglio && TAGLI[String(rec.taglio)]){ card.taglio = String(rec.taglio); card.taglioLabel = TAGLI[String(rec.taglio)]; }

    if(rec.size==='custom' && +rec.w>0 && +rec.h>0){
      card.size='custom'; card.w=+rec.w; card.h=+rec.h;
      card.sizeLabel = 'Su misura · ' + trim(rec.w) + '×' + trim(rec.h) + ' cm';
      const est = C.estimateCustom(tipo, +rec.w, +rec.h, qty);
      if(est==null){ card.needsQuote = true; }
      else { card.total = est; card.unit = est/qty; card.estimate = true; }
    } else {
      card.size = rec.size;
      card.sizeLabel = sizeLabel(rec.size);
      const pr = C.priceFor(tipo, rec.size, qty);
      if(pr==null){ card.needsQuote = true; }
      else { card.total = pr; card.unit = pr/qty; }
    }
    if(card.needsQuote) card.contacts = true;
    if(rec.reason) card.reasons.push({ ic:'check_circle', html:String(rec.reason) });
    return card;
  }

  const REASON = {
    vinile:'Il <b>vinile classico</b> è versatile, resistente ed economico: si applica ovunque, ideale per uso quotidiano e promozione.',
    trasparente:'Il <b>trasparente</b> lascia vedere la superficie sotto: effetto “stampato sul vetro”, perfetto per vetrine e prodotti.',
    olografico:'L’<b>olografico</b> cangiante dà il massimo impatto visivo: la scelta più “wow” per merch e brand.',
    prespaziato:'Il <b>prespaziato</b> è intagliato a filo con pellicola di trasferimento: applicazione facilissima su vetrine, auto e insegne.',
    magnetico:'Il <b>magnetico</b> aderisce a frigo e metallo senza colla ed è riposizionabile: ottimo per i gadget.',
    dtf:'Il <b>termoadesivo DTF</b> si applica a caldo sui tessuti: perfetto per t-shirt e abbigliamento personalizzato.',
    oro:'La finitura <b>oro</b> brillante dà eleganza e lusso a inviti, confezioni regalo e prodotti premium.'
  };

  function recommendFromAnswers(a){
    let tipo = USO_TIPO[a.uso] || 'vinile';
    if(a.superficie==='vetro' && (tipo==='vinile')) tipo='trasparente';
    if(a.superficie==='tessuto') tipo='dtf';
    let size = a.size || '7x7';
    if(tipo==='prespaziato' && ['3x3','5x3','5x5','7x5'].indexOf(size)>=0) size='7x7';
    const card = buildCard({ tipo, size, qty:a.qty||'100', reason:REASON[tipo] });
    // extra tailored reasons
    if(a.uso==='vetrine' && tipo==='trasparente') card.reasons.push({ ic:'window', html:'Sul <b>vetro</b> l’adesivo trasparente sparisce e resta solo la grafica.' });
    if(card.qty>=300) card.reasons.push({ ic:'savings', html:'Con '+card.qty+' pezzi il prezzo unitario scende sensibilmente.' });
    if(card.needsQuote) card.reasons.push({ ic:'support_agent', html:'Per questa combinazione ti prepariamo un <b>preventivo su misura</b>.' });
    return card;
  }

  /* ---------- state ---------- */
  const answers = {};
  let step = 0;
  let slideNext = false;
  const chat = [];
  let aiBusy = false;
  let chatGen = 0;

  function labelFor(qid){
    const q = QUESTIONS.find(x=>x.id===qid);
    const o = q && q.opts.find(o=>o.v===answers[qid]);
    return o ? o.t : '';
  }

  function render(){
    if(step >= QUESTIONS.length){ renderResult(); return; }
    const q = QUESTIONS[step];
    const slide = slideNext ? ' from-right' : ''; slideNext = false;
    const dots = QUESTIONS.map((_,i)=>'<i class="'+(i<step?'done':i===step?'on':'')+'"></i>').join('');
    const trail = QUESTIONS.slice(0,step).map(p=>
      '<button class="g-tag" data-jump="'+p.id+'" title="Modifica risposta"><span class="msr">'+p.icon+'</span>'+esc(labelFor(p.id))+'<span class="ed msr">edit</span></button>'
    ).join('');
    root.innerHTML =
      '<div class="g-step'+slide+'">'+
        '<div class="g-progress"><span class="g-count">Domanda '+(step+1)+' di '+QUESTIONS.length+'</span><span class="g-dots">'+dots+'</span></div>'+
        '<div class="g-trail">'+trail+'</div>'+
        '<div class="g-q">'+q.q+'</div>'+
        '<div class="g-sub">'+q.sub+'</div>'+
        '<div class="g-opts">'+ q.opts.map(o=>
          '<button class="g-opt" data-v="'+o.v+'"><span class="g-ic"><span class="msr">'+o.ic+'</span></span><span><span class="g-t">'+o.t+'</span><span class="g-d">'+o.d+'</span></span></button>'
        ).join('') +'</div>'+
        '<button class="g-back"><span>‹</span> Indietro</button>'+
      '</div>';
    root.querySelectorAll('.g-opt').forEach(b=> b.addEventListener('click', ()=>{
      answers[q.id] = b.dataset.v; step++; render(); keepInView();
    }));
    root.querySelector('.g-back').addEventListener('click', ()=>{ if(step===0){ renderIntro(); } else { step--; render(); } });
    root.querySelectorAll('.g-tag').forEach(t=> t.addEventListener('click', ()=>{ step = QUESTIONS.findIndex(x=>x.id===t.dataset.jump); render(); }));
  }

  function priceLineHtml(r){
    if(r.needsQuote) return '<div class="g-price g-quote"><b>Prezzo su richiesta</b><small>combinazione fuori listino</small></div>';
    return '<div class="g-price"><small>'+(r.estimate?'stima':'')+'</small><b>'+(r.estimate?'≈ ':'')+fmt(r.total)+'</b><small>'+fmt(r.unit)+' / pz · IVA incl.</small></div>';
  }
  function contactsHtml(){
    return '<div class="g-alt"><span class="msr">support_agent</span><span>Ti prepariamo un preventivo: <a href="'+CT.whatsappUrl+'" target="_blank" rel="noopener">WhatsApp '+CT.whatsapp+'</a> · <a href="mailto:'+CT.supporto+'">'+CT.supporto+'</a></span></div>';
  }

  function renderResult(){
    const r = recommendFromAnswers(answers);
    const slide = slideNext ? ' from-right' : ''; slideNext = false;
    const trail = QUESTIONS.map(p=>
      '<button class="g-tag" data-jump="'+p.id+'"><span class="msr">'+p.icon+'</span>'+esc(labelFor(p.id))+'<span class="ed msr">edit</span></button>'
    ).join('');
    root.innerHTML =
      '<div class="g-result'+slide+'">'+
        '<div class="g-result-head"><span class="dot"></span> La nostra proposta per te</div>'+
        '<div class="g-trail">'+trail+'</div>'+
        '<div class="g-result-grid">'+
          '<div class="g-card">'+
            '<div class="g-vis"><span class="badge badge-red">Consigliato</span><span class="ph" data-label="Mockup · '+esc(r.tipoLabel)+'"></span></div>'+
            '<div class="g-card-body">'+
              '<h3>'+r.tipoLabel+'</h3>'+
              '<div class="g-specs">'+
                '<span class="chip"><span class="msr">straighten</span>'+r.sizeLabel+'</span>'+
                '<span class="chip"><span class="msr">tag</span>'+r.qty+' pz</span>'+
              '</div>'+
              priceLineHtml(r)+
            '</div>'+
          '</div>'+
          '<div class="g-why">'+
            '<h4>Perché te lo consigliamo</h4>'+
            '<ul class="g-reasons">'+ r.reasons.map(x=>'<li><span class="msr">'+(x.ic||'check_circle')+'</span><span>'+x.html+'</span></li>').join('') +'</ul>'+
            (r.contacts ? contactsHtml() : '')+
            '<p class="g-note"><span class="msr">check_circle</span> Puoi cambiare materiale, dimensione e quantità quando vuoi. Spedizione gratis sopra '+fmt0(C.META.freeShippingOver)+'.</p>'+
          '</div>'+
        '</div>'+
        '<div class="g-order">'+
          '<div class="g-order-head"><span class="badge badge-red">Ultimo passaggio</span><h4>Ti convince? Carica la grafica e vai all’ordine</h4></div>'+
          '<div class="g-order-grid">'+
            '<div class="g-upcol">'+
              '<div class="upload-zone g-upzone">'+
                '<div class="u-ic"><span class="msr" style="font-size:2.4rem">cloud_upload</span></div>'+
                '<h4>Trascina qui il tuo file</h4>'+
                '<p>oppure clicca per selezionarlo · PDF, JPG o PNG</p>'+
              '</div>'+
              '<input type="file" id="g-file" accept=".pdf,.jpg,.jpeg,.png" hidden>'+
              '<button type="button" class="btn btn-ghost btn-sm btn-demo" id="g-demo"><span class="msr ic">auto_fix_high</span> Non hai un file? Prova con un esempio</button>'+
            '</div>'+
            '<div class="preview-stage" id="g-stage">'+
              '<div class="ph preview-ph" data-label="Anteprima sticker"></div>'+
              '<canvas class="preview-canvas" id="g-canvas" aria-label="Anteprima del tuo sticker"></canvas>'+
            '</div>'+
            '<div class="g-buy">'+
              '<ul class="rows">'+
                '<li><span>Prodotto</span><b>'+r.tipoLabel+'</b></li>'+
                '<li><span>Dimensione</span><b>'+r.sizeLabel+'</b></li>'+
                '<li><span>Quantità</span><b>'+r.qty+' pz</b></li>'+
              '</ul>'+
              (r.needsQuote
                ? '<div class="tot"><div class="pl">Totale</div><div class="pv" style="font-size:1.3rem">Su richiesta</div></div><div class="pu">Ti mandiamo un preventivo su misura</div>'
                : '<div class="tot"><div class="pl">Totale</div><div class="pv">'+(r.estimate?'≈ ':'')+fmt(r.total)+'</div></div><div class="pu">'+fmt(r.unit)+' / pz · IVA e spedizione incluse'+(r.estimate?' (stima)':'')+'</div>') +
              '<button class="btn btn-primary btn-block" id="g-buy" disabled>Acquista ora <span class="ic">›</span></button>'+
              '<p class="g-buy-note"><span class="msr" style="font-size:.9rem;vertical-align:-2px">lock</span> Pagamento sicuro · Controllo file incluso</p>'+
            '</div>'+
          '</div>'+
          '<div class="g-order-foot">'+
            '<a href="#configuratore" id="g-apply"><span class="msr" style="font-size:1.1rem">tune</span> Voglio modificare materiale, dimensione o quantità</a>'+
            '<button class="g-restart"><span class="msr" style="font-size:1.1rem">replay</span> Ricomincia dalle domande</button>'+
          '</div>'+
        '</div>'+
      '</div>';

    root.querySelectorAll('.g-tag').forEach(t=> t.addEventListener('click', ()=>{ step = QUESTIONS.findIndex(x=>x.id===t.dataset.jump); render(); keepInView(); }));
    root.querySelector('.g-restart').addEventListener('click', ()=>{
      for(const k in answers) delete answers[k];
      chat.length = 0; chatGen++; aiBusy = false; step = 0; renderIntro(); keepInView();
    });
    root.querySelector('#g-apply').addEventListener('click', ()=>{ applyToConfig(r); });

    /* upload + preview + buy */
    const upz = root.querySelector('.g-upzone');
    const inp = root.querySelector('#g-file');
    const stage = root.querySelector('#g-stage');
    const canvas = root.querySelector('#g-canvas');
    const buy = root.querySelector('#g-buy');
    if(window.WowPreview) window.WowPreview.register(canvas);
    const refreshPreview = ()=>{
      if(!window.WowPreview || !window.WowPreview.hasImage()) return;
      stage.classList.add('has-image');
      window.WowPreview.update({ tipo:r.tipo, shapeMode:'rect', finitura:'standard', size:r.size });
    };
    const setLoaded = (name)=>{
      upz.querySelector('h4').textContent = '✓ ' + (name||'File caricato');
      upz.querySelector('p').textContent = 'Perfetto — controlliamo noi il file prima della stampa.';
      upz.style.borderColor = 'var(--mint)';
      if(!r.needsQuote) buy.disabled = false;
      refreshPreview();
    };
    const handleFile = (f)=>{
      if(/(png|jpe?g)$/i.test(f.name) && f.type.indexOf('image')===0){
        const rd = new FileReader();
        rd.onload = ()=>{ window.WowPreview ? window.WowPreview.setImage(rd.result).then(()=>setLoaded(f.name)).catch(()=>setLoaded(f.name)) : setLoaded(f.name); };
        rd.readAsDataURL(f);
      } else { setLoaded(f.name); }
    };
    upz.addEventListener('click', ()=> inp.click());
    ['dragover','dragenter'].forEach(ev=> upz.addEventListener(ev, e=>{ e.preventDefault(); upz.style.borderColor='var(--red)'; }));
    ['dragleave','drop'].forEach(ev=> upz.addEventListener(ev, e=> e.preventDefault()));
    upz.addEventListener('drop', e=>{ const f = e.dataTransfer.files && e.dataTransfer.files[0]; if(f) handleFile(f); });
    inp.addEventListener('change', ()=>{ const f = inp.files && inp.files[0]; if(f) handleFile(f); });
    root.querySelector('#g-demo').addEventListener('click', ()=>{
      if(window.WowPreview) window.WowPreview.setImage(window.WOW_ASSET_BASE+'wowsticker-logo.png').then(()=>setLoaded('Esempio: logo WowSticker'));
    });
    buy.addEventListener('click', ()=>{
      const cc = document.querySelector('.cart-count');
      if(cc) cc.textContent = (parseInt(cc.textContent,10)||0) + 1;
      const toast = document.getElementById('config-toast');
      if(toast){ toast.classList.add('show'); setTimeout(()=>toast.classList.remove('show'), 2600); }
      buy.innerHTML = '✓ Aggiunto al carrello';
    });
  }

  function applyToConfig(r){
    if(window.WowConfig) window.WowConfig.applyPreset({ tipo:r.tipo, taglio:r.taglio, size:r.size, qty:r.qty, w:r.w, h:r.h });
  }

  /* ---------- intro hub ---------- */
  const CHIPS = [
    { ic:'inventory_2', l:'Packaging<br>e prodotti', q:'Mi servono sticker per il packaging dei miei prodotti' },
    { ic:'star',        l:'Sticker<br>con logo',     q:'Voglio sticker personalizzati con il mio logo' },
    { ic:'storefront',  l:'Vetrine<br>e vetri',      q:'Cerco adesivi per la vetrina del mio negozio' },
    { ic:'checkroom',   l:'T-shirt<br>e tessuti',    q:'Voglio personalizzare delle t-shirt' },
    { ic:'auto_awesome',l:'Merch<br>e brand',        q:'Voglio sticker per il mio merch, con effetto wow' }
  ];

  function renderIntro(){
    root.innerHTML =
      '<div class="g-intro">'+
        '<div class="g-hub">'+
          '<div class="g-hub-col g-ask-col">'+
            '<div class="g-col-head"><span class="g-col-ic"><span class="msr">chat</span></span><h3>Scrivi cosa ti serve</h3></div>'+
            '<div class="g-searchbar">'+
              '<span class="msr">forum</span>'+
              '<input type="text" id="g-ask" placeholder="Es. “Mi servono sticker in vinile per il packaging”" autocomplete="off">'+
              '<button class="btn btn-primary" id="g-send"><span class="btxt">Consigliami</span> <span class="ic">→</span></button>'+
            '</div>'+
            '<div class="g-ex-label">Prova con un esempio:</div>'+
            '<div class="g-chips">'+ CHIPS.map((c,i)=>'<button class="g-chip" data-chip="'+i+'"><span class="msr">'+c.ic+'</span><span>'+c.l+'</span></button>').join('') +'</div>'+
            '<div class="g-outcome">'+
              '<span class="g-outcome-ic"><span class="msr">auto_awesome</span></span>'+
              '<p><b>Cosa ottieni:</b> ti consigliamo materiale, dimensione e quantità più adatti, con il prezzo a listino.</p>'+
              '<span class="g-outcome-sticker" aria-hidden="true"><span>IL TUO<br>STICKER<br>IDEALE</span></span>'+
            '</div>'+
          '</div>'+
          '<div class="g-hub-col g-guided-col">'+
            '<div class="g-col-head"><span class="g-col-ic"><span class="msr">explore</span></span><h3>Preferisci essere guidato?</h3></div>'+
            '<div class="g-guided-card">'+
              '<img class="g-guided-illu" src="assets/guide-clipboard.jpg" alt="" loading="lazy" decoding="async">'+
              '<h4>Rispondi a 4 domande</h4>'+
              '<p>Meno di 30 secondi per il consiglio perfetto, con prezzo.</p>'+
              '<button class="btn btn-ghost btn-lg" id="g-wizard">Inizia il percorso <span class="ic">→</span></button>'+
            '</div>'+
          '</div>'+
        '</div>'+
        '<div class="g-assure">'+
          '<div class="g-assure-item"><span class="g-assure-ic"><span class="msr">bolt</span></span><div><b>Risposta in 30 secondi</b><span>Consiglio immediato, senza impegno.</span></div></div>'+
          '<div class="g-assure-item"><span class="g-assure-ic"><span class="msr">local_shipping</span></span><div><b>Spedizione gratis sopra '+fmt0(C.META.freeShippingOver)+'</b><span>Produzione 24/48h + spedizione 24/72h.</span></div></div>'+
          '<div class="g-assure-item"><span class="g-assure-ic"><span class="msr">star</span></span><div><b>Prezzo trasparente</b><span>Prezzi reali a listino, IVA inclusa.</span></div></div>'+
        '</div>'+
        '<p class="g-foot-note"><span class="msr">favorite</span> Siamo qui per aiutarti a creare lo sticker perfetto.</p>'+
      '</div>';
    const input = root.querySelector('#g-ask');
    const send = ()=>{ const v = input.value.trim(); if(v) startChat(v); };
    root.querySelector('#g-send').addEventListener('click', send);
    input.addEventListener('keydown', e=>{ if(e.key==='Enter') send(); });
    root.querySelectorAll('[data-chip]').forEach(b=> b.addEventListener('click', ()=> startChat(CHIPS[+b.dataset.chip].q)));
    root.querySelector('#g-wizard').addEventListener('click', ()=>{ step = 0; slideNext = true; render(); keepInView(); });
  }

  /* ---------- AI chat ---------- */
  // Prodotti reali dal catalogo (Shopify quando disponibile): l'assistente
  // conosce e consiglia solo ciò che è effettivamente in vendita.
  const TIPO_KEYS = C.PRODUCTS.map(function(p){ return p.key; });
  const PROD_LINES = C.PRODUCTS.map(function(p){
    return p.label + ' (' + (p.use || 'uso generico') + (p.start ? ' · da €' + Math.round(p.start) : ' · prezzo su richiesta') + ')';
  }).join('; ');
  const AI_GUIDE =
    'Sei un consulente vendite di WowSticker (wowsticker.it), e-commerce italiano di sticker adesivi personalizzati. Parli italiano, tono caldo e concreto, come un commesso esperto e simpatico. Risposte BREVI e conversazionali: 2-3 frasi al massimo.\n'+
    'PRODOTTI a catalogo (nome → usi · prezzo di partenza — consiglia SOLO questi): ' + PROD_LINES + '\n'+
    'USI TIPICI degli sticker (usali per fare esempi e capire il cliente; scegli ogni volta i 3-4 più pertinenti, non sempre gli stessi): logo del brand; decorare oggetti; personalizzare regali, pacchetti e biglietti; etichettare oggetti personali, contenitori o materiale scolastico; ricordi di viaggi, compleanni e momenti speciali; bomboniere e decorazioni per matrimoni, battesimi e lauree; gadget promozionali da regalare ai clienti; vetrine, espositori e materiale pubblicitario; etichette per prezzi, ingredienti o istruzioni; packaging (scatole, buste, carta velina); omaggi da inserire negli ordini; promuovere profili social, podcast, band e progetti creativi.\n'+
    'COME SCEGLI IL MATERIALE: la superficie di applicazione guida la scelta \u2014 su vetro e superfici trasparenti o scure valuta il vinile trasparente (sfondo trasparente, effetto \u201cstampato sul vetro\u201d), mentre su cartone, carta e plastica il vinile classico con sfondo pieno bianco rende i colori pi\u00f9 brillanti; su tessuto serve il DTF; per scritte in tinta unita su vetrine/auto il prespaziato. Se il cliente vuole un tocco premium o un effetto particolare proponi olografico (cangiante) oppure oro metallizzato; altrimenti resta sul semplice. SE il catalogo li include: gli STICKER IN FOGLIO (pi\u00f9 soggetti diversi raccolti su un unico foglio) sono la scelta giusta per set e collezioni, kit da distribuire, eventi e feste (matrimoni, lauree, fiere) e sticker pack per il merch; il MEZZO TAGLIO (kiss-cut: lo sticker si stacca dal foglietto di supporto) \u00e8 ideale come gadget da regalare a ospiti e clienti, omaggio da inserire negli ordini, o quando serve staccare lo sticker con facilit\u00e0 senza rovinarlo. NON consigliarli se non sono nell\u2019elenco PRODOTTI.\n'+
    'DIMENSIONI a listino: 3x3, 5x3, 5x5, 7x5, 7x7, 10x7, 10x10, 12x5, 12x12 cm; oltre queste è possibile un FORMATO SU MISURA (qualsiasi larghezza×altezza in cm) con prezzo stimato al metro quadro.\n'+
    'QUANTITÀ a listino: 50, 100, 200, 300, 500, 1000, 2000 pz (minimo assoluto 10 pz: sotto i 50 o quantità intermedie vanno confermate con l’assistenza). Più alta la quantità, più basso il prezzo unitario.\n'+
    'REGOLE: spedizione €5, GRATIS sopra €50 di prodotti; produzione 24/48h + spedizione 24/72h; anteprima di stampa opzionale €5 per grafica entro 24h; file PDF/JPG/PNG (300 DPI consigliati), c’è un servizio grafico se il file è scarso; sconto 10% col primo ordine iscrivendosi alla newsletter.\n'+
    'NON inventare MAI prezzi: li calcola il sistema dalla combinazione materiale+dimensione+quantità. Per combinazioni fuori listino (quantità <50 o intermedie, misure particolari) proponi comunque il prodotto e invita a confermare con l’assistenza: WhatsApp '+CT.whatsapp+', '+CT.supporto+'. Per una proposta normale NON menzionare i contatti: basta il pulsante verso il configuratore.\n'+
    'TONO: amichevole e caloroso, ma sempre professionale; dai sempre del tu. Ogni risposta ha questo ritmo: prima riconosci con entusiasmo quello che il cliente ha appena detto (\u201cPerfetto!\u201d, \u201cOttimo!\u201d, \u201cFantastico!\u201d \u2014 varia, non ripetere la stessa parola due volte di fila), poi fai UNA sola domanda con 2-4 esempi concreti dentro la frase. Al massimo UNA emoji per messaggio, solo quando \u00e8 naturale.\n'+
    'ESEMPI DI STILE (adatta al contesto, non copiare alla lettera):\n'+
    '\u2022 \u201cCiao! Benvenuto in WowSticker \ud83d\ude0a Perfetto, un logo personalizzato \u00e8 un classico! Dimmi: dove pensi di applicarli? Ad esempio sul packaging dei tuoi prodotti, come gadget per i tuoi clienti, su una vetrina, oppure per decorare regali e oggetti?\u201d\n'+
    '\u2022 \u201cOttimo! Per il packaging servono sticker resistenti. Una domanda: il tuo logo \u00e8 un\u2019immagine semplice in uno o due colori, oppure ha pi\u00f9 colori e dettagli?\u201d\n'+
    '\u2022 \u201cPerfetto, allora ti serve uno sticker pratico e resistente! Che dimensione immagini, pi\u00f9 piccola (5-7 cm) o pi\u00f9 grande (10 cm e oltre)?\u201d\n'+
    '\u2022 \u201cFantastico! Ultima cosa: quanti sticker ti servono? Poche decine per iniziare, oppure qualche centinaio?\u201d\n'+
    '\u2022 \u201cPerfetto! Per una fiera hai tante opzioni. Dimmi: gli sticker servono soprattutto per il vostro stand, oppure come gadget da regalare ai visitatori?\u201d\n'+
    '\u2022 \u201cFantastico, le etichette personalizzate fanno una grande differenza sul packaging! Dimmi: su che superficie andranno applicate? Ad esempio cartone, plastica oppure vetro?\u201d\n'+
    '\u2022 \u201cPerfetto! Sul vetro un adesivo trasparente crea un bellissimo effetto \u201cstampato\u201d. Preferisci un look semplice e pulito, oppure un effetto speciale come olografico o oro metallizzato?\u201d\n'+
    'REGOLA DI AVANZAMENTO: OGNI tua risposta deve far progredire la conversazione: o contiene UNA domanda, oppure contiene la proposta (recommend valorizzato). MAI chiudere con una frase di solo commento senza domanda (es. \u201cOttimo, allora ti serviranno sticker su misura!\u201d e basta: VIETATO — aggiungi subito la domanda successiva).\n'+
    'COME CONDUCI: è una consulenza, non un quiz. Al PRIMO messaggio saluta con calore e fai subito la prima domanda utile, sul modello: "Ciao! Benvenuto in WowSticker 😊 Dimmi un po’: a cosa vorresti destinare gli sticker? Ad esempio per il packaging dei tuoi prodotti, per personalizzare regali e oggetti, come gadget per i clienti, per una vetrina o altro?" (adattala a ciò che il cliente ha già scritto). UNA domanda alla volta, breve e naturale, saltando ciò che il cliente ha già detto, nell’ordine: 1) a cosa servono; 2) su che superficie o materiale andranno applicati (es. cartone, plastica, vetro, metallo, tessuto) — ti serve per valutare sfondo pieno o trasparente; 3) la grafica è solo un logo o una scritta in tinta unita, oppure una stampa a colori con testi e informazioni? (ti serve per scegliere tra prespaziato, etichette e sticker stampati); 4) preferisce un look semplice e pulito oppure un effetto speciale (olografico cangiante, oro metallizzato)?; 5) dimensione indicativa — se il cliente dà una misura precisa (es. 8x13 cm) accettala come formato su misura e passa SUBITO alla domanda successiva, senza commentarla da sola; 6) che taglio preferisce: sagomato sulla forma della grafica, squadrato, con angoli arrotondati o tondo; 7) quantità. Sono tante: salta senza chiedere tutto ciò che il cliente ha già detto o che è ovvio dal contesto. Quando la domanda ha risposte prevedibili, offri 2-4 opzioni brevi (max 4 parole) nel campo "options". Proponi un prodotto SOLO quando conosci uso, dimensione, taglio e quantità: se ne manca anche solo una, NON proporre — chiedi quella mancante (di norma 3-5 scambi); se il cliente ti dà tutto subito, proponi subito.\n'+
    'QUANDO PROPONI \u2014 REGOLA FERREA: appena conosci uso, dimensione e quantit\u00e0, DEVI compilare il campo recommend nel JSON (mai lasciarlo null a quel punto): \u00e8 il sito a mostrare la scheda prodotto con il prezzo. NON descrivere formato/quantit\u00e0/prezzo a parole, NON dire \u201cpotrei consigliarti\u201d o chiedere conferma: proponi con decisione. La tua reply \u00e8 SOLO un consiglio caloroso in 1-2 frasi: presenti il prodotto adatto e spieghi in breve il perch\u00e9. NON chiedere se il cliente ha già un file, NON proporre o citare l’anteprima di stampa, NON riepilogare o “confermare” un ordine, NON dire di inviare nulla via WhatsApp/email né di “procedere dal sito”: al file, all’anteprima e al pagamento pensa il configuratore, che il cliente apre già impostato col pulsante sotto la tua proposta. Cita i contatti SOLO se la combinazione è fuori listino.\n'+
    'FORMATO: rispondi SEMPRE e SOLO con JSON valido, nessun testo fuori dal JSON.\n'+
    'Mentre fai domande: {"reply":"testo","options":["opzione 1","opzione 2"],"recommend":null} (options può essere null).\n'+
    'Quando proponi: {"reply":"frase calorosa che introduce la proposta e spiega in breve il perché","options":null,"recommend":{"tipo":"' + TIPO_KEYS.join('|') + '","size":"3x3|5x3|5x5|7x5|7x7|10x7|10x10|12x5|12x12|custom","w":numero_cm_solo_se_custom,"h":numero_cm_solo_se_custom,"qty":"50|100|200|300|500|1000|2000","taglio":"sagomato|quadrato|angoli|tondo"}}\n'+
    'Usa size "custom" SOLO per misure fuori dai formati standard (includi w e h in cm). Se la misura del cliente corrisponde a un formato a listino anche INVERTITO (es. 5x7 \u2192 usa "7x5", 7x10 \u2192 usa "10x7"), usa il formato standard, NON "custom": il prezzo sar\u00e0 esatto invece che stimato. Il campo "taglio" riflette la preferenza del cliente; se non l\u2019ha detta usa "sagomato".';

  const ALLOWED = {
    tipo: TIPO_KEYS,
    size:['3x3','5x3','5x5','7x5','7x7','10x7','10x10','12x5','12x12','custom'],
    qty:['50','100','200','300','500','1000','2000']
  };

  function validRec(rec){
    if(!rec) return false;
    if(!Object.keys(ALLOWED).every(function(k){ return ALLOWED[k].indexOf(String(rec[k]))!==-1; })) return false;
    if(String(rec.size)==='custom') return (parseFloat(rec.w)>0 && parseFloat(rec.h)>0);
    return true;
  }

  function parseAI(t){
    t = String(t).trim().replace(/^```(json)?/i,'').replace(/```$/,'').trim();
    const m = t.match(/\{[\s\S]*\}/);
    if(m){ try{ return JSON.parse(m[0]); }catch(e){} }
    return { reply: t.replace(/[{}"]/g,' ').trim() || 'Puoi dirmi qualcosa in più?', recommend:null };
  }

  // Ask the model: prima Cloudflare Workers AI (se WOWASSISTANT_WORKER_URL è
  // impostato), poi fallback a window.claude (anteprima Claude Design).
  async function askModel(prompt){
    let url = (window.WOWASSISTANT_WORKER_URL || '').trim();
    if(url && !/^https?:\/\//i.test(url)) url = 'https://' + url;   // tollera URL senza protocollo
    if(url){
      try{
        const resp = await fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ prompt: prompt }) });
        if(resp.ok){ const j = await resp.json(); const t = j.text || j.response; if(t) return t; }
      }catch(e){ /* worker offline → prova il fallback */ }
    }
    if(window.claude && window.claude.complete) return await window.claude.complete(prompt);
    throw new Error('no-ai');
  }

  function startChat(text){ chat.length = 0; chat.push({ role:'user', text }); slideNext = true; renderChat(); keepInView(); askAI(); }

  function chatCardHtml(r, ci){
    const price = r.needsQuote
      ? '<div class="g-price g-quote"><b>Prezzo su richiesta</b></div>'
      : '<div class="g-price"><small>'+(r.estimate?'stima':'')+'</small><b>'+(r.estimate?'≈ ':'')+fmt(r.total)+'</b><small>'+fmt(r.unit)+' / pz · IVA incl.</small></div>';
    return '<div class="g-prodcard" data-ci="'+ci+'">'+
      '<span class="badge badge-red">La nostra proposta</span>'+
      '<h4>'+r.tipoLabel+'</h4>'+
      (r.reasons[0] ? '<p class="g-pwhy">'+r.reasons[0].html+'</p>' : '')+
      '<div class="g-specs">'+
        '<span class="chip"><span class="msr">straighten</span>'+r.sizeLabel+'</span>'+
        '<span class="chip"><span class="msr">tag</span>'+r.qty+' pz</span>'+
        (r.taglioLabel ? '<span class="chip"><span class="msr">content_cut</span>'+r.taglioLabel+'</span>' : '')+
      '</div>'+
      price+
      (r.contacts ? contactsHtml() : '')+
      '<a href="#configuratore" class="btn btn-primary btn-block g-gocfg" data-ci="'+ci+'">Vai al configuratore già impostato <span class="ic">›</span></a>'+
      '<p class="g-pnote">Controlla dimensione e quantità, carica il file e ordina: ogni opzione resta modificabile.</p>'+
    '</div>';
  }

  function renderChat(){
    const slide = slideNext ? ' from-right' : ''; slideNext = false;
    const last = chat[chat.length-1];
    const quick = (!aiBusy && last && last.role==='ai' && !last.card && last.opts && last.opts.length)
      ? '<div class="g-quick">'+ last.opts.map((o,i)=>'<button data-q="'+i+'">'+escHtml(o)+'</button>').join('') +'</div>' : '';
    root.innerHTML =
      '<div class="g-chat'+slide+'">'+
        '<div class="g-chat-head">'+
          '<span class="g-av"><span class="msr">support_agent</span></span>'+
          '<span><b>Assistente WowSticker</b><small><i></i> Ti risponde subito</small></span>'+
          '<button class="g-quit"><span class="msr" style="font-size:1.05rem">checklist</span> <span class="qtxt">Preferisco la guida alla scelta</span></button>'+
        '</div>'+
        '<div class="g-msgs" id="g-msgs">'+
          chat.map((m,ci)=> m.card ? chatCardHtml(m.card, ci) : '<div class="g-msg '+(m.role==='user'?'me':'ai')+'">'+escHtml(m.text)+'</div>').join('')+
          quick+
          (aiBusy ? '<div class="g-typing"><i></i><i></i><i></i></div>' : '')+
        '</div>'+
        '<div class="g-searchbar g-chatbar">'+
          '<span class="msr">forum</span>'+
          '<input type="text" id="g-ask" placeholder="Scrivi la tua risposta…" autocomplete="off" '+(aiBusy?'disabled':'')+'>'+
          '<button class="btn btn-primary" id="g-send" '+(aiBusy?'disabled':'')+'><span class="btxt">Invia</span> <span class="ic">›</span></button>'+
        '</div>'+
      '</div>';
    const msgs = root.querySelector('#g-msgs'); msgs.scrollTop = msgs.scrollHeight;
    const input = root.querySelector('#g-ask');
    const send = ()=>{ const v = input.value.trim(); if(!v || aiBusy) return; chat.push({ role:'user', text:v }); renderChat(); askAI(); };
    root.querySelector('#g-send').addEventListener('click', send);
    input.addEventListener('keydown', e=>{ if(e.key==='Enter') send(); });
    root.querySelectorAll('.g-quick button').forEach(b=> b.addEventListener('click', ()=>{ if(aiBusy) return; chat.push({ role:'user', text: last.opts[+b.dataset.q] }); renderChat(); askAI(); }));
    root.querySelectorAll('.g-gocfg').forEach(a=> a.addEventListener('click', ()=>{ const r = chat[+a.dataset.ci] && chat[+a.dataset.ci].card; if(r) applyToConfig(r); }));
    root.querySelector('.g-quit').addEventListener('click', ()=>{ chatGen++; aiBusy = false; step = 0; slideNext = true; render(); keepInView(); });
  }

  async function askAI(){
    aiBusy = true; renderChat();
    const gen = chatGen;
    const transcript = chat.filter(m=>m.text).map(m=> (m.role==='user'?'CLIENTE: ':'ASSISTENTE: ')+m.text).join('\n');
    let out;
    try{
      const raw = await askModel(AI_GUIDE + '\n\nConversazione:\n' + transcript + '\n\nRispondi ora con il JSON.');
      if(gen !== chatGen) return;
      out = parseAI(raw);
    }catch(e){
      if(gen !== chatGen) return;
      aiBusy = false;
      chat.push({ role:'ai', text:'Ops, in questo momento non riesco a risponderti. Prova la guida alla scelta qui sotto: quattro domande rapide e arrivi alla proposta giusta.' });
      renderChat(); return;
    }
    aiBusy = false;
    const rec = out && out.recommend;
    const valid = validRec(rec);
    chat.push({ role:'ai', text: (out && out.reply) ? String(out.reply) : 'Perfetto!',
                opts: (!valid && out && Array.isArray(out.options)) ? out.options.filter(o=>typeof o==='string' && o.trim()).slice(0,4) : null });
    if(valid) chat.push({ role:'ai', card: buildCard(rec) });
    renderChat();
  }

  function keepInView(){
    const top = root.closest('.guide');
    if(!top) return;
    const y = top.getBoundingClientRect().top + window.scrollY - 60;
    if(Math.abs(window.scrollY - y) > 80) window.scrollTo({ top:y, behavior:'smooth' });
  }

  /* ---------- expose engine for the hero inline chat ---------- */
  window.WowGuide = {
    AI_GUIDE: AI_GUIDE, ALLOWED: ALLOWED, parseAI: parseAI, validRec: validRec,
    buildCard: buildCard, contactsHtml: contactsHtml,
    TIPO_LABEL: C.TIPO_LABEL, fmt: fmt
  };

  if(root) renderIntro();
})();
